import Vue from 'vue'
import { Popup, Cell, Tab, Tabs } from 'vant'

Vue.use(Popup)
Vue.use(Cell)
Vue.use(Tab)
Vue.use(Tabs)
